export const API_URL = process.env.REACT_APP_API_URL;
export const API_URL_V2 = process.env.REACT_APP_API_URL_V2;
export const REWARD_API_URL = process.env.REACT_APP_REWARD_API_URL;
export const REWARD_API_URL_V2 = process.env.REACT_APP_REWARD_API_URL_V2;